import message from './ant-design-vue/es/message';

message.config({
  maxCount: 1,
});

export default {
  hostname:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3000'
      : `https://${location.host}/api`,
  alert: {
    mixin: ({ type, title }) => {
      message[type](title);
    },
  },
};
